 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"physical":"physical","group-device":"group-device"}[chunkId]||chunkId) + "." + {"chunk-12f021f0":"d2c607ad","chunk-17dc781a":"d08bd516","chunk-184405f0":"64789453","chunk-28c8de06":"82aa6d1a","chunk-2ece4d04":"4191433a","chunk-354217a8":"d195ff93","chunk-3ac328dc":"e9f94fa1","chunk-381895ae":"7af91307","chunk-3911d52f":"3b17958e","chunk-3a85ce0d":"844dd71a","chunk-3dc070da":"3c9efb5c","chunk-41a3ce1c":"9cfc087b","chunk-39152376":"3e699f38","chunk-4a454b04":"490c7c2b","chunk-5b728a94":"c014a06f","chunk-69702c4e":"f932f61c","chunk-6b0df53a":"167d2eb8","chunk-6e842000":"52d72a48","chunk-71cf6f34":"c9d559f9","chunk-73f38de6":"bfaa32da","chunk-86f867ec":"d152b185","chunk-8a0958d0":"d49783cf","chunk-965ac2c8":"a2a2ac2f","chunk-a5a53b14":"3dde9186","chunk-c1451ef4":"42e5226f","chunk-ce509970":"59c796cf","chunk-ce76569a":"3f2d0179","chunk-d917c1f2":"fed1cc28","chunk-da2d0fbe":"b9c83a7b","chunk-e389ba9a":"9382739b","chunk-eb992782":"36e08e96","chunk-f32a1854":"f5213313","chunk-fdd47cd6":"1f37b6bb","chunk-fe070fc8":"f71a1894","chunk-08fa7d7e":"8437af9f","chunk-52d73463":"a2f6f218","chunk-5775bdc2":"63541eaf","chunk-11348c6b":"e395752a","chunk-3317253e":"f81f99dd","chunk-5ae58522":"f0630345","chunk-65870ddd":"c66f1f37","chunk-51c63cdb":"d694afd3","chunk-4f12ee0a":"a4312dc8","chunk-ac557876":"05d07842","chunk-217eb1b0":"19c26d2b","chunk-5d0d8a00":"186a692b","chunk-7a1578f0":"334a8de2","physical":"b2134a46","chunk-da141bc8":"5b2ee201","group-device":"6077e51e","chunk-2d216214":"dda534f6","chunk-370ae2c2":"3b3f257d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-12f021f0":1,"chunk-17dc781a":1,"chunk-184405f0":1,"chunk-28c8de06":1,"chunk-2ece4d04":1,"chunk-3ac328dc":1,"chunk-381895ae":1,"chunk-3911d52f":1,"chunk-3a85ce0d":1,"chunk-3dc070da":1,"chunk-39152376":1,"chunk-4a454b04":1,"chunk-5b728a94":1,"chunk-69702c4e":1,"chunk-6b0df53a":1,"chunk-6e842000":1,"chunk-71cf6f34":1,"chunk-73f38de6":1,"chunk-86f867ec":1,"chunk-8a0958d0":1,"chunk-965ac2c8":1,"chunk-a5a53b14":1,"chunk-c1451ef4":1,"chunk-ce509970":1,"chunk-d917c1f2":1,"chunk-da2d0fbe":1,"chunk-e389ba9a":1,"chunk-eb992782":1,"chunk-f32a1854":1,"chunk-fdd47cd6":1,"chunk-08fa7d7e":1,"chunk-52d73463":1,"chunk-5775bdc2":1,"chunk-11348c6b":1,"chunk-3317253e":1,"chunk-65870ddd":1,"chunk-4f12ee0a":1,"chunk-ac557876":1,"chunk-217eb1b0":1,"chunk-7a1578f0":1,"physical":1,"chunk-da141bc8":1,"group-device":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"physical":"physical","group-device":"group-device"}[chunkId]||chunkId) + "." + {"chunk-12f021f0":"edb415eb","chunk-17dc781a":"e9730c9c","chunk-184405f0":"3be7235b","chunk-28c8de06":"f9f6a188","chunk-2ece4d04":"e658822d","chunk-354217a8":"31d6cfe0","chunk-3ac328dc":"9bdcc070","chunk-381895ae":"8381012a","chunk-3911d52f":"d6886b95","chunk-3a85ce0d":"0133666b","chunk-3dc070da":"f9cf0e61","chunk-41a3ce1c":"31d6cfe0","chunk-39152376":"a06c58a1","chunk-4a454b04":"943eb3b1","chunk-5b728a94":"dfef4f5c","chunk-69702c4e":"9e090b7e","chunk-6b0df53a":"49490d9c","chunk-6e842000":"18d617eb","chunk-71cf6f34":"f138d7eb","chunk-73f38de6":"ad3d8686","chunk-86f867ec":"9a1d20c8","chunk-8a0958d0":"e66caa6f","chunk-965ac2c8":"772b79a7","chunk-a5a53b14":"7f528c88","chunk-c1451ef4":"2d375c08","chunk-ce509970":"fdb90805","chunk-ce76569a":"31d6cfe0","chunk-d917c1f2":"434601cb","chunk-da2d0fbe":"94e41853","chunk-e389ba9a":"24c62b54","chunk-eb992782":"48ca987d","chunk-f32a1854":"72bec127","chunk-fdd47cd6":"092c824f","chunk-fe070fc8":"31d6cfe0","chunk-08fa7d7e":"835b7d39","chunk-52d73463":"5ca58efa","chunk-5775bdc2":"b83e5e0a","chunk-11348c6b":"d7cfc610","chunk-3317253e":"4a630f48","chunk-5ae58522":"31d6cfe0","chunk-65870ddd":"3e8c5ced","chunk-51c63cdb":"31d6cfe0","chunk-4f12ee0a":"409110a4","chunk-ac557876":"7b880e13","chunk-217eb1b0":"b47d6a01","chunk-5d0d8a00":"31d6cfe0","chunk-7a1578f0":"f2632eb6","physical":"bf9370cd","chunk-da141bc8":"dc731852","group-device":"88996113","chunk-2d216214":"31d6cfe0","chunk-370ae2c2":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/teacher/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
